/** Legacy Resource Center on leapeasy.com (pre-Zendesk partner channel). */
export const LEGACY_RESOURCE_CENTER_URL = 'https://www.leapeasy.com/resource';

/** Zendesk Help Center — switch RESOURCE_CENTER_URL here after Marta sign-off. */
export const ZENDESK_RESOURCE_CENTER_URL = 'https://leappartners.zendesk.com/hc/en-us';

/** Active portal Resource Center destination (menu link + in-portal redirects). */
export const RESOURCE_CENTER_URL = LEGACY_RESOURCE_CENTER_URL;

/** In-portal paths that redirect to RESOURCE_CENTER_URL for bookmark compatibility. */
export const RESOURCE_CENTER_REDIRECT_PATHS = [
  '/resource',
  '/resource-center',
  '/dashboard/resource',
];
